import { Box, keyframes, Skeleton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.4; }
`;

const steps = [
  'Fetching page data…',
  'Loading products…',
  'Preparing assets…',
  'Almost there…',
];

export const PageBuilderV2Loader = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStepIndex((prev) => (prev + 1) % steps.length);
    }, 1400);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header skeleton */}
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1.5, mb: 4 }}>
        <Skeleton height={32} variant="circular" width={32} />
        <Box sx={{ flex: 1 }}>
          <Skeleton height={28} variant="rounded" width="40%" />
          <Skeleton height={14} sx={{ mt: 0.75 }} variant="rounded" width="20%" />
        </Box>
      </Box>

      {/* Section skeletons */}
      {[
        { fields: 3, label: 'Basic Information' },
        { fields: 2, label: 'Page Banners' },
        { fields: 2, label: 'Publisher Images' },
        { fields: 1, label: 'Buying Guide' },
        { fields: 4, label: 'Products' },
      ].map((section, i) => (
        <Box
          key={section.label}
          sx={{
            animation: `${fadeIn} 0.4s ease both`,
            animationDelay: `${i * 80}ms`,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            mb: 2,
            overflow: 'hidden',
          }}
        >
          <Box sx={{
            alignItems: 'center',
            borderBottom: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            gap: 1.5,
            px: 2.5,
            py: 1.5,
          }}>
            <Skeleton height={18} variant="rounded" width="25%" />
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, p: 2.5 }}>
            {Array.from({ length: section.fields }).map((_, j) => (
              <Skeleton
                // eslint-disable-next-line react/no-array-index-key
                key={j}
                height={40}
                sx={{ flex: '1 1 160px' }}
                variant="rounded"
              />
            ))}
          </Box>
        </Box>
      ))}

      {/* Status text */}
      <Box sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 1.5,
        justifyContent: 'center',
        mt: 4,
      }}>
        <Box sx={{
          animation: `${pulse} 1.4s ease-in-out infinite`,
          backgroundColor: 'primary.main',
          borderRadius: '50%',
          height: 8,
          width: 8,
        }} />
        <Typography
          key={stepIndex}
          color="text.disabled"
          sx={{ animation: `${fadeIn} 0.3s ease both` }}
          variant="body2"
        >
          {steps[stepIndex]}
        </Typography>
      </Box>
    </Box>
  );
};
